import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyBl728DpjbUdRaPadgaJoNrsGUt0Hmw9go",
  authDomain: "interstices-net.firebaseapp.com",
  projectId: "interstices-net",
  storageBucket: "interstices-net.appspot.com",
  messagingSenderId: "474026742342",
  appId: "1:474026742342:web:ae0afaf2f49f3816fef047"
};
// init app
initializeApp(firebaseConfig)

// init firestore
const db = getFirestore()

// Initialize Cloud Storage and get a reference to the service
const storage = getStorage();

// init firebase auth
const auth = getAuth()


export { db, storage, auth }
